// extracted by css-extract-rspack-plugin
var _1 = "ElementIcon-m_d1Badge-GkomWZL7";
var _2 = "ElementIcon-m_element-e0VY8WPa";
var _3 = "ElementIcon-m_fixContrast-dsjf670Q";
var _4 = "ElementIcon-m_invert-dQNqCW7A";
export { _1 as "d1Badge", _2 as "element", _3 as "fixContrast", _4 as "invert" }
